/**
 * 工程表の決まり文を、いまの会社の言葉と製品で埋めて渡す（#142 段5、docs/54 No.56〜128）。
 *   contract の SCHEDULE_MSG・PARTNER_LINK_MSG・SCHEDULE_EXPORT_MSG・REPORT_REASON_LABEL は {schedule}・{task}・{contractor}・{siteShort}・{project}・{pw:…}
 *   を含む。ここの同じ名前の入れ物から読むと、文字はその場で t() を通り（関数は答えを t() に通す）、
 *   「工程表」⇄「スケジュール」・「工程」⇄「作業」・「協力会社」⇄「外注先」・「現場」⇄「案件」・「雨で中止」⇄「中止」になる。
 *   読むのは描くとき（Shell・協力会社のページが言葉を入れたあと）。モジュールの一番上で文字を取って置かない（会社の言葉が入る前の既定になる）
 */
import {
  PARTNER_LINK_MSG as PARTNER_LINK_MSG_RAW,
  REPORT_REASON_LABEL as REPORT_REASON_LABEL_RAW,
  SCHEDULE_EXPORT_MSG as SCHEDULE_EXPORT_MSG_RAW,
  SCHEDULE_MSG as SCHEDULE_MSG_RAW,
  scheduleShowsRain,
} from "@genbaryoku/contract";
import { t } from "../../labels.js";
import { currentProduct } from "../../lib/product.js";

const cache = new WeakMap<object, object>();
/** 文字は t()、関数は答えを t()、入れ子の入れ物も同じように（読むたびに今の言葉で） */
function filled<T extends object>(o: T): T {
  const hit = cache.get(o);
  if (hit) return hit as T;
  const p = new Proxy(o, {
    get(target, key, recv) {
      const v: unknown = Reflect.get(target, key, recv);
      if (typeof v === "string") return t(v);
      if (typeof v === "function") return (...a: unknown[]) => {
        const r: unknown = (v as (...x: unknown[]) => unknown).apply(target, a);
        return typeof r === "string" ? t(r) : r;
      };
      if (v && typeof v === "object") return filled(v);
      return v;
    },
  });
  cache.set(o, p);
  return p;
}

export const SCHEDULE_MSG = filled(SCHEDULE_MSG_RAW);
export const PARTNER_LINK_MSG = filled(PARTNER_LINK_MSG_RAW);
export const SCHEDULE_EXPORT_MSG = filled(SCHEDULE_EXPORT_MSG_RAW);
export const REPORT_REASON_LABEL = filled(REPORT_REASON_LABEL_RAW);

/** 雨の印・列・メニューと中止のわけ（雨／ほか）を出すか（いまの製品。営業力は出さない。#142 段5 No.125〜128） */
export const showsRain = (): boolean => scheduleShowsRain(currentProduct());
/** 「ほか」の中止の短い文：「中止（メモ）」。メモが無ければ 現場力「中止（ほか）」／営業力「中止」（わけを選ばないので） */
export const stopOtherText = (note: string | null | undefined): string => (note ? `中止（${note}）` : showsRain() ? `中止（${SCHEDULE_MSG_RAW.stopReasonOther}）` : "中止");
/** 中止のアイコン：現場力は傘、営業力は一時停止（#142 段5） */
export const stopIcon = (): "umbrella" | "pause" => (showsRain() ? "umbrella" : "pause");
